import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCloseAuction, removeExtendedAuction } from 'slices/offersSocketSlice';
import CountDown from 'components/participates/countDown';
import timer from '../../assets/timer.svg';

const ItemExtended = () => {
  const dispatch = useDispatch();
  const { detail } = useSelector((state) => state.detail);
  const { closeDate, serverDate, id } = detail;

  const { extendedAuction, statusExtendedAuction } = useSelector((state) => state.offersSocket);
  const { auctionId } = extendedAuction;

  const handleOfferAgain = () => {
    dispatch(removeExtendedAuction());
  };

  const [selected, setSelected] = useState(true);
  const handleToogle = () => {
    setSelected(!selected);
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  const [dataSocket, setDataSocket] = useState(false);

  const validateSocketData = () => {
    let data = false;
    if (auctionId.toString() === id.toString()) {
      data = true;
    }
    return setDataSocket(data);
  };

  useEffect(() => {
    if (auctionId !== undefined) {
      validateSocketData();
    }
  }, [auctionId, dataSocket]);

  useEffect(() => {
    scrollEvent();
  }, []);

  useEffect(() => {
    if (auctionId !== undefined) {
      if (auctionId === id) {
        if (statusExtendedAuction && extendedAuction.status === 'CLOSED_WITH_WINNERS') {
          dispatch(getCloseAuction());
        }
      }
    }
  }, []);

  return (
    <>
      <div className="bg-alabaster pt-5 p-sm-3 pb-30 d-block d-sm-none sticky-resumen-mobile">
        <div className="wrap">
          <button
            type="button"
            className="header bg-alabaster d-flex justify-content-between btn-link text-left"
            onClick={handleToogle}>
            <div className="title opacity-70 ml-2">
              <h2>¡Estás a dos de ganar!</h2>
            </div>
            <div className="icon-title font-weight-bold text-tangaroa">
              {selected ? (<i className="fas fa-minus" />) : (<i className="fas fa-plus" />)}
            </div>
          </button>

          {selected && (
            <div className="content bg-alabaster text-center">
              <img src={timer} alt="exito" />
              <p className="text-tangaroa">
                La Subasta en la que estás participando ha entrado a tiempo extra.
                A partir de este momento tendrás 2 minutos adicionales para continuar
                pujando y ser ganador.
              </p>
              <button type="button" className="btn btn-primary my-30 w-100" id="sbs-dsb-dgr-btn-mor" onClick={handleOfferAgain}>Ofertar de nuevo</button>
            </div>
          )}
        </div>
      </div>

      <div className="mb-30 d-none d-sm-block font-weight-bold">
        Finaliza en
        <CountDown
          closeDate={closeDate}
          todayDate={serverDate} />
      </div>
      <div className="bg-alabaster d-none d-sm-block p-3 pt-30 pt-sm-5 text-center">
        <h2>¡Estás a dos de ganar!</h2>
        <img src={timer} alt="exito" />
        <p className="text-tangaroa">
          La Subasta en la que estás participando ha entrado a tiempo extra.
          A partir de este momento tendrás 2 minutos adicionales para continuar
          pujando y ser ganador.
        </p>
        <button type="button" className="btn btn-primary mt-30 mb-15 w-100" id="sbs-dsb-dgr-btn-mor" onClick={handleOfferAgain}>Ofertar de nuevo</button>
      </div>
    </>
  );
};

export default ItemExtended;
